import styled from "styled-components/macro";

export const DivUnderlineEmphasis = styled.div<{ width: number }>`
  background-color: var(--gold);
  height: 0.8rem;
  width: ${(props) => props.width}rem;
`;
